<template>
  <div class="provement">
    <toptitle :title1="titlework" />
    <div>
      <img src="../../assets/sansheng.jpg"
           alt="">
    </div>
    <section v-if="prove.C_PROVE_TYPE === '20'">
      <h3>在职证明</h3>
      <p class="title">
        <span></span>
        兹证明<u>{{ prove.NAME }}</u>，性别：<u>{{prove.SEX_DESCR}}</u>，身份证号码为<u>{{prove.NATIONAL_ID}}</u>，<u>{{prove.LAST_HIRE_DT | changeDate}}</u>入职华峰至今，
        <!--在<u>{{prove.COMPANY_DESCR}}</u>工作，任职<u>{{prove.DEPT_DESCR}}</u>部门-->现为我公司<u>{{prove.POSN_DESCR}}</u>。
      </p>
      <p class="title"><span></span>特此证明。</p>
      <p class="bottom"><u>{{prove.COMPANY_DESCR}}</u></p>
      <p class="bottom"><u>{{prove.EFFDT | changeDate}}</u></p>
    </section>
    <section v-else-if="prove.C_PROVE_TYPE === '10'">
      <h3>收入证明</h3>
      <p class="title">
        <span></span>
        兹有我公司员工<u>{{ prove.NAME }}</u>性别：<u>{{prove.SEX_DESCR}}</u>，身份证号码为<u>{{prove.NATIONAL_ID}}</u>，
        <!--自<u>{{prove.LAST_HIRE_DT | changeDate}}</u>至今在<u>{{prove.COMPANY_DESCR}}</u>工作，任职<u>{{prove.DEPT_DESCR}}</u>部门-->现任本单位职务为<u>{{prove.POSN_DESCR}}</u>，年收入为税前<u
           style="min-width:30px;">{{prove.AMOUNT}}
        </u>元，大写<u style="min-width:30px;">{{prove.AMOUNT_DESCR}}</u>
      </p>

      <p class="title"><span></span>特此证明。</p>
      <p class="bottom"><u>{{prove.COMPANY_DESCR}}</u></p>
      <p class="bottom"><u>{{prove.EFFDT | changeDate}}</u></p>
    </section>
    <section v-else>
      <h3>居住证明</h3>
      <p class="title">
        <span></span>
        姓名：<u>{{ prove.NAME }}</u>性别：<u>{{prove.SEX_DESCR}}</u>，身份证号码：<u>{{prove.NATIONAL_ID}}</u>，现就职于<u>{{prove.COMPANY_DESCR}}</u>工作，现住华峰员工公寓<u style="text-decoration:none;">____</u>栋<u
           style="text-decoration:none;">____</u>房间。
      </p>

      <p class="title"><span></span>特此证明。</p>
      <p class="bottom"><u>{{prove.COMPANY_DESCR}}</u></p>
      <p class="bottom"><u>{{prove.EFFDT | changeDate}}</u></p>
    </section>
  </div>
</template>

<script>
import toptitle from '../toptitle'
import axios from 'axios'
import { proveHistoryDataApi } from '../../request/api'
import { Toast } from 'vant'
import _ from 'lodash'
export default {
  name: 'provement',
  data() {
    return {
      titlework: '证明查看',
      prove: this.$route.query,
    }
  },
  methods: {},
  components: {
    toptitle,
  },
  created() {
    // console.log(this.$route.query)
  },
  filters: {
    changeDate(val) {
      let reg = /(\d{4})\-(\d{2})\-(\d{2})/
      return val.replace(reg, '$1年$2月$3日')
    },
  },
}
</script>

<style lang="less" scoped>
.provement {
  background: #fff;
  height: 100%;
}
section {
  padding: 0 16px;
  h3 {
    text-align: center;
    line-height: 44px;
    font-weight: bold;
  }
  .title {
    span {
      margin-left: 30px;
    }
  }
  p {
    line-height: 36px;
    u {
      padding: 8px;
      //   border-bottom: 1px solid #000;
    }
  }
  .bottom {
    text-align: right;
  }
}
div {
  img {
    padding: 10px;
    width: 250px;
  }
}
</style>
